export const headerHeight = '56px';
export const headerHeightMobile = headerHeight;
export const navigationWidth = '250px';
export const navigationWrapperSizeMobile = headerHeightMobile;
export const overlayWidthMobile = '300px';
export const footerHeight = '56px';
export const headerHoverColor = 'rgba(255, 255, 255, 0.25)';
export const headerFocusColor = 'rgba(255, 255, 255, 0.4)';